import React from "react";
import { Row, Col } from "react-bootstrap";
import { H1, H2, H4, P, Backlink, ImageOffset } from "../common";
import { titleCase } from "../../vars/ThemeOptions";
import styled from "styled-components";
import RichText from "../../richText/RichText";
import { rejig2020Title } from "../modules";

const Styled = {};
Styled.PageIntro = styled(Row)`
  padding: 6vh ${({ mainImage }) => (mainImage ? "3vh" : 0)};
  align-items: center;
  .col {
    -webkit-flex: initial;
  }
  .has-image {
    margin: 0;
  }
`;

export const Intro = ({ title, subtitle, json, backlink, left, mainImage }) => {
  //const { fluid } = mainImage ? mainImage : { fluid: null };
  const { fixed } = mainImage ? mainImage : { fixed: null };
  const classes = ["flex-column"];
  if (mainImage) classes.push("has-image");
  return (
    <Styled.PageIntro className={classes.join(" ")}>
      {backlink ? (
        <Backlink to={"/" + backlink}>
          Back to {backlink === "/" ? "Main" : titleCase(backlink)}
        </Backlink>
      ) : null}
      {subtitle ? (
        <>
          <H4>{rejig2020Title(title)}</H4>
          <H2>{subtitle}</H2>
        </>
      ) : (
        <H1>{rejig2020Title(title)}</H1>
      )}
      {/* {fluid && (
        <div style={{ marginTop: "3vh", marginBottom: "-2vh", width: "100%" }}>
          <ImageOffset fluid={fluid} alt={mainImage.title} />
        </div>
      )} */}
      {fixed && (
        <div style={{ marginTop: "3vh", marginBottom: "-2vh", width: "100%" }}>
          <ImageOffset fixed={fixed} alt={mainImage.title} />
        </div>
      )}
      {json && (
        <Col
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <P left={left ? left : undefined} fluid>
            <RichText json={json} />
          </P>
        </Col>
      )}
    </Styled.PageIntro>
  );
};
